"use strict";

import { Application } from "../main/application.js";
import { Screen } from "../systems/core/screen.js";
import { UIContainer } from "./uiContainer.js";

export class UIBaseContainer extends UIContainer {
    constructor(config) {
        if (config === undefined) {
            config = {};
        }
        config.rect = {
            anchorX: { min: 0, max: 1 },
            anchorY: { min: 0, max: 1 },
            scale: config.scale ?? 1
        };
        config.parent = Application.main.stage;
        super(config);
    }

    getRealWorldPosition() {
        return this.parentContainer.toGlobal(this.getPosition());
    }

    get lossyScaleX() {
        return this.scale.x;
    }
    get lossyScaleY() {
        return this.scale.y;
    }
    get lossyScale() {
        return this.lossyScaleY;
    }

    _refreshPosition() {
        let parentPreferredBounds = {...Screen.main.size.bounds};
        this._width = parentPreferredBounds.width * this.rect.scale.x;
        this._height = parentPreferredBounds.height * this.rect.scale.y;
        
        this.calculatedRect.bounds.left = -this._width / 2;
        this.calculatedRect.bounds.bottom = this._height / 2;
        this.calculatedRect.bounds.right = this._width / 2;
        this.calculatedRect.bounds.top = -this._height / 2;
        this.calculatedRect.center.x = 0;
        this.calculatedRect.center.y = 0;
        this.calculatedRect.size.width = this._width;
        this.calculatedRect.size.height = this._height;
    }

    onResolutionChanged() {
        if (this.parentContainer === undefined) return;

        this.scale.x = 1;
        this.scale.y = 1;

        this._onResolutionWillChangeCallback?.();

        this._refreshPosition();

        this._onResolutionChangedCallback?.();

        for (let i = 0; i < this.children.length; i++) {
            this.children[i].onResolutionChanged();
        }

        this._onResolutionChangedAfterCallback?.();

        this.scale.x = this.rect.scale.x;
        this.scale.y = this.rect.scale.y;
    }
}